import axios from "axios";
import { API_URL, FOLDERPATH } from "../Constants/config";
import { toast } from "react-toastify";
import { PERSONAL_DETAIL_BY_CLIENT_LOADING, PERSONAL_DETAIL_BY_CLIENT_SUCCESS, PERSONAL_DETAIL_BY_CLIENT_FAILED } from "../Constants/personalDetailByClientConstants";
import { handleApiError } from "../Helper/actionHelper";

export const getSavePersonalDetailByclient = (formData,referenceNumber,personalComplete, epUploader) => async (dispatch) => {
  let msg="Cannot create case.Duplicate case exist";
  try {
    let userLocalData = JSON.parse(localStorage.getItem('userVerificationCandidate'));  
    dispatch({ type: PERSONAL_DETAIL_BY_CLIENT_LOADING });

console.log("tpm",epUploader);

    let ff = new FormData();
    ff.append("token", userLocalData.id);
    ff.append("formdata",JSON.stringify(formData));


    if(epUploader["parental_consent_file"] !== undefined){
      ff.append("parental_consent_file",epUploader.parental_consent_file);
    }


    if(epUploader["cv_document_file"] !== undefined){
      ff.append("cv_document_file",epUploader.cv_document_file);
    }

    if(epUploader["candidate_photo"] !== undefined){
      ff.append("candidate_photo",epUploader.candidate_photo);
    }

    if(epUploader["covid_vaccine_file"] !== undefined){
      ff.append("covid_vaccine_file",epUploader.covid_vaccine_file);
    }

    if(epUploader["form_16_file"] !== undefined){
      ff.append("form_16_file",epUploader.form_16_file);
    }
    if(epUploader["vehicle_registration_document"] !== undefined){
      ff.append("vehicle_registration_document",epUploader.vehicle_registration_document);
    }

   if(personalComplete){
    personalComplete=0;
   }
   else{
    personalComplete=1;
   }
    ff.append("duplicate_check",personalComplete);
    ff.append("referenceNo",referenceNumber);
    // formData.append("pp",formData.candidateData.uploader.parental_consent_file);
    



    console.log("gg",formData)



    const requestData = { 
      token:
      userLocalData.id,
      duplicate_check:0,
      referenceNo:referenceNumber,
      ...formData
      // "group": 10,
      //"referenceNo": "291664450159",
    };
    // for (var i in formData) {
    //   if (i === "customfields_data") {
    //     requestData[i] = formData[i];
    //   } else if (formData[i] && formData[i].length > 0) {
    //     debugger
    //     requestData[i] = formData[i];
    //   }
    // }

    //return false;
    const headers = {
      "Content-Type": "application/json",
      Username: "ibridge",
      Password: "ibridge@2020",
    };

    //axios.defaults.baseURL = API_URL;
    const { data } = await axios.post(FOLDERPATH +
      "/ClientApi/initiateCaseDiy", 
      ff,
      {
     headers: headers,
      }
    );
    
    if (data.status === "success") {
      const msg = "Saved Successfully";
      toast.success(msg, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }

    dispatch({
      type: PERSONAL_DETAIL_BY_CLIENT_SUCCESS,
      payload: data,
    });

    handleApiError(data);

  } catch (error) {
    dispatch({
      type: PERSONAL_DETAIL_BY_CLIENT_FAILED,
      payload:
        error.response && error.response.data.message
          ? error.response
          : error.response,
    });
   
    handleApiError(error);
  }
};

export const deletePersonalDetailByClientData = () => async (dispatch) => {
  dispatch({
    type: PERSONAL_DETAIL_BY_CLIENT_SUCCESS,
    payload: [],
  });
};